import type {CustomFormItemValue} from '../../../types';

export const getSelectOptionDisabled =
	(value: CustomFormItemValue[] | string[]) => (option: string) => {
		const index = value.findIndex((val) =>
			typeof val === 'string' ? val === option : val.key === option,
		);
		if (index < 0) return false;

		const foundValue = value[index];
		return typeof foundValue === 'string'
			? false
			: foundValue.disabled === true;
	};
